import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { InterviewRequestService } from "../../../services/InterviewRequestService";
import { useGeneralContext } from "../../General/Context";

import InterviewPreviewHeader from "../ViewInterview/InterviewPreviewHeader";
import InterviewPerviewPage from "../ViewInterview/InterviewPreviewPage";
import { InterviewService } from "../../../services/InterviewService";
import InterviewContextProvider from "../InterviewContext";
export default function InterviewDetails({ match }) {
  const [showRejectModal, setRejectModalShow] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [error, setError] = useState();
  const { t } = useTranslation();
  const [rejectComment, setRejectComment] = useState();
  const [interview, setInterview] = useState();
  let history = useHistory();
  const { id, interviewRequestId } = useParams();
  const { userInformation } = useGeneralContext();

  useEffect(() => {
    InterviewService.getDetailsById(id).then((data) => {
      setInterview(data);
    });
  }, [id]);

  function closeRejectModal() {
    setRejectComment();

    setRejectModalShow(false);
  }
  function onsubmitReject() {
    if (!rejectComment) {
      setError(t("the comment is required"));
      return;
    }
    InterviewRequestService.reject({
      interviewRequestId: interviewRequestId,
      comment: rejectComment
    }).then(() => {
      refreshReapplicationList();
      window.close();
      closeRejectModal();
    });
  }

  function onSubmitAccept() {
    InterviewRequestService.cloneLastInterview(id, interviewRequestId).then(
      (data) => {
        closeAcceptModal();
        refreshReapplicationList();
        history.push(`/interview/createOrEdit/${data}`);
      }
    );
  }

  function openRejectModalModal() {
    setRejectModalShow(true);
  }

  function openAcceptModal() {
    setShowAcceptModal(true);
  }

  function onChangeComment({ target }) {
    setRejectComment(target.value);
  }

  function closeAcceptModal() {
    setShowAcceptModal(false);
  }
  function refreshReapplicationList() {
    if (window.opener)
      window.opener.postMessage("REAPPLICATIONREFRESH", window.location.origin);
  }

  return interview ? (
    <>
      <InterviewContextProvider>
        <InterviewPreviewHeader interview={interview}>
          {userInformation.permissions?.Accept_Reapplications && (
            <div className="text-end col-auto">
              <button
                className="app-button btn-prime btn-lg"
                onClick={(event) =>
                  openAcceptModal(event, {
                    interviewId: id,
                    interviewRequestId: interviewRequestId
                  })
                }
              >
                {" "}
                {t("Accept")}
              </button>
              <button
                className="btn app-button btn-second btn-lg"
                onClick={(event) => openRejectModalModal()}
              >
                {" "}
                {t("Reject")}
              </button>
            </div>
          )}
        </InterviewPreviewHeader>
        <InterviewPerviewPage
          id={id}
          noActions={true}
          interview={interview}
          setInterview={setInterview}
        />

        <ModalContainer
          modalTitle={t("Comment")}
          closeModal={closeRejectModal}
          crossmarkAction={closeRejectModal}
          cancelButtonTitle={t("Cancel")}
          cancelButtonAction={closeRejectModal}
          submitButtonTitle={t("Done")}
          submitButtonType="submit"
          submitButtonAction={onsubmitReject}
          isOpen={showRejectModal}
          modalSize="sm"
        >
          <div className="label-wrapper">
            {error && <div className="error-msg">{error}</div>}
          </div>
          <textarea
            className="form-control"
            onChange={onChangeComment}
            size={500}
          ></textarea>
        </ModalContainer>
        <ModalContainer
          modalTitle={t("Clone Interview")}
          closeModal={closeAcceptModal}
          crossmarkAction={closeAcceptModal}
          cancelButtonTitle={t("Cancel")}
          cancelButtonAction={closeAcceptModal}
          submitButtonTitle={t("Continue")}
          submitButtonType="submit"
          submitButtonAction={onSubmitAccept}
          isOpen={showAcceptModal}
          modalSize="sm"
        >
          {t("A new interview will be created. Do you want to continue?")}
        </ModalContainer>
      </InterviewContextProvider>
    </>
  ) : (
    <></>
  );
}
